var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All-Inspections",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Inspections-My-Sites-View-in-List---Priority---state-forms",
    transform: "translate(-1051.000000, -894.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-6",
    transform: "translate(1035.000000, 878.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-View-report-WO-18",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 13.5,
    height: 13.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "add_comment_black_24dp",
    transform: "translate(3.000000, 2.000000)",
    fill: "#616674"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 L11.2,4.2 L11.2013833,6.53781031 C10.841611,6.026239 10.3604301,5.60622732 9.79971752,5.31965233 L9.8,4.9 L8.08319043,4.90014009 C8.072138,4.90004676 8.06107446,4.9 8.05,4.9 L8.017,4.9 L6.3,4.9 L6.3,1.4 L1.4,1.4 L1.4,12.6 L9.8,12.6 L9.8,12.3956926 L10.9152365,13.4438149 C10.6874663,13.743684 10.3420141,13.9499074 9.94933205,13.9920327 L9.8,14 L1.393,14 C0.668294118,14 0.0738027682,13.4419377 0.00637024221,12.7343293 L0,12.6 L0,1.4 C0,0.675294118 0.558062284,0.0746020761 1.26567067,0.00644005699 L1.4,0 L7,0 Z M8.05,5.6 C9.793,5.6 11.2,7.007 11.2,8.75 C11.2,9.289 11.0606563,9.79048437 10.8194844,10.2356953 L10.71,10.423 L12.894,12.6 L11.9,13.594 L9.716,11.41 C9.233,11.718 8.659,11.9 8.043,11.9 C6.307,11.9 4.9,10.493 4.9,8.75 C4.9,7.007 6.307,5.6 8.05,5.6 Z M4.34519797,9.80097262 C4.49234147,10.3206901 4.74589696,10.7957072 5.08083482,11.2009942 L2.8,11.2 L2.8,9.8 L4.34519797,9.80097262 Z M8.05,7 C7.084,7 6.3,7.784 6.3,8.75 C6.3,9.716 7.084,10.5 8.05,10.5 C9.016,10.5 9.8,9.716 9.8,8.75 C9.8,7.784 9.016,7 8.05,7 Z M4.61965233,7.00028248 C4.40155008,7.42702128 4.26073705,7.8998264 4.21567367,8.4002374 L2.8,8.4 L2.8,7 L4.61965233,7.00028248 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCheck);
export default __webpack_public_path__ + "static/media/reportCheck.da9d040e616cd1bae363f017fc39ab37.svg";
export { ForwardRef as ReactComponent };